export default {
  storefront_not_found: {
    title: 'Nessuna vetrina trovata',
    description: 'Crea una vetrina.',
  },
};
